import { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';
import { LocationFormModel, LocationFormSchema } from './LocationFormModel';
import { zodResolver } from '@hookform/resolvers/zod';
import GuestLocationFormDisplay from './GuestLocationFormDisplay';

interface GuestLocationFormLogicProps {
  initialValues: LocationFormModel;
  locationId?: number;
}

const GuestLocationFormLogic: FunctionComponent<GuestLocationFormLogicProps> = ({ initialValues, locationId }) => {
  const form = useForm<LocationFormModel>({
    mode: 'onSubmit',
    defaultValues: initialValues,
    resolver: zodResolver(LocationFormSchema),
  });

  // Guest users cannot submit forms
  const handleSubmit = async (_data: LocationFormModel) => {
    // No-op for guest users
  };

  return <GuestLocationFormDisplay form={form} onSubmit={handleSubmit} locationId={locationId} />;
};

export default GuestLocationFormLogic;
